import { Component, OnDestroy } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

import * as enumType from 'src/app/shared/enums'
import * as module from 'src/app/shared/enums/module-types';
import * as toaster from 'src/app/shared/enums/toaster';
import * as permission from 'src/app/shared/enums/permission'
import { Subject } from 'rxjs';
@Component({
  selector: 'app-base',
  template: '',
})
export class BaseComponent {
  searchStr = '';
  public formMode: typeof enumType.formMode = enumType.formMode;
  public customFields: typeof enumType.customFields = enumType.customFields;

  public moduleType: typeof module.moduleType = module.moduleType;
  public subModuleType: typeof module.subModuleType = module.subModuleType;

  public modules: typeof permission.modules = permission.modules;
  public subModules: typeof permission.subModules = permission.subModules;
  public permissionTypes: typeof permission.permissionTypes = permission.permissionTypes;

  public routingActionType: typeof module.routingActionType = module.routingActionType;
  public routingModuleType: typeof module.routingModuleType = module.routingModuleType;
  public routingAuthenticationModuleType: typeof module.routingAuthenticationModuleType = module.routingAuthenticationModuleType;

  public routingDashboardModuleType: typeof module.routingDashboardModuleType = module.routingDashboardModuleType;
  public routingInteractionsModuleType: typeof module.routingInteractionsModuleType = module.routingInteractionsModuleType;
  public routingInteractionsSubModuleType: typeof module.routingInteractionsSubModuleType = module.routingInteractionsSubModuleType;
  public routingCollaborationModuleType: typeof module.routingCollaborationModuleType = module.routingCollaborationModuleType;
  public routingCollaborationSubModuleType: typeof module.routingCollaborationSubModuleType = module.routingCollaborationSubModuleType;
  public routingBusinessModuleType: typeof module.routingBusinessModuleType = module.routingBusinessModuleType;
  public routingBusinessSubModuleType: typeof module.routingBusinessSubModuleType = module.routingBusinessSubModuleType;
  public routingOrganizerModuleType: typeof module.routingOrganizerModuleType = module.routingOrganizerModuleType;
  public routingOrganizationSubModuleType: typeof module.routingOrganizationSubModuleType = module.routingOrganizationSubModuleType;
  public routingFeaturesSubModuleType: typeof module.routingFeaturesSubModuleType = module.routingFeaturesSubModuleType;
  public routingFeaturesModuleType: typeof module.routingFeaturesModuleType = module.routingFeaturesModuleType;
  public routingTemplatesSubModuleType: typeof module.routingTemplatesSubModuleType = module.routingTemplatesSubModuleType;

  public toastType: typeof toaster.severity = toaster.severity;
  public filterQueryParm: typeof enumType.filterQueryParm = enumType.filterQueryParm;
  public SearchQueryParm: typeof enumType.SearchQueryParm = enumType.SearchQueryParm;
  public scroll_distance = 1;
  public scroll_up_distance = 2;
  public throttle = 150;
  // public virtualScroll = true;
  // public lazy = true;
  // public virtualScrollItemSize = 50;
  // public scrollHeight = "200px";

  protected destroy$ = new Subject<void>();

  setAndUpdateValidators(control: AbstractControl, newValidator: ValidatorFn | ValidatorFn[] | null): void {
    control?.setValidators(newValidator);
    control?.updateValueAndValidity();
  }

  clearAndUpdateValidators(control: AbstractControl): void {
    if (control.validator) {
      control?.clearValidators();
    }
    control?.updateValueAndValidity();
  }

  protected cleanupSubscriptions(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // ngOnDestroy(): void {
  //   this.destroy$.next();
  //   this.destroy$.complete();

  //   console.log(`Unsubscribed from: ${this.constructor.name}`);
  // }

}